import React, { Component } from "react";
import { VstButton } from "vstui";
import classNames from "classnames";

export default class AcceptCookies extends Component {
  constructor() {
    super();
    this.state = {
      cookiesAllowed: Fraction.Helpers.Users.getUserData("allow-cookies")
    };
    this.accept = this.accept.bind(this);
  }

  componentDidMount() {
    const link = document.getElementById("cookie-policy");
    link && link.focus();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.viewer && nextProps.viewer) {
      nextProps.viewer.Viewport.setAutofocus(false);
    }
  }

  accept() {
    Fraction.Helpers.Users.saveUserData("allow-cookies", true, true);
    this.setState({
      cookiesAllowed: Fraction.Helpers.Users.getUserData("allow-cookies")
    });
  }

  render() {
    const { className: classNameProp } = this.props;
    const className = classNames("cookie-banner", classNameProp);

    if (this.state.cookiesAllowed || !Fraction.Brand.Cookies.notify) {
      return null;
    }
    return (
      <div className={className} 
           role="dialog"
           aria-live="polite" 
           aria-label={i18n.t("main-menu.cookie-policy")}
           aria-describedby="cookieconsent:desc">
        <div className="cookie-banner__content">
          <div id="cookieconsent:desc" className="cookie-banner__message">
            {window.toHTML(
              i18n.t("footer.accept-cookies", {
                url:
                  Fraction.Brand.Cookies.url ||
                  i18n.t("locations.zendesk-cookies")
              })
            )}
          </div>
          <div className="cookie-banner__button-container">
            <VstButton
              className="cookie-banner__button"
              id="accept-cookies"
              onClick={this.accept}
            >
              {i18n.t("footer.close")}
            </VstButton>
          </div>
        </div>
      </div>
    );
  }
}
